import { IonContent, Platform } from '@ionic/angular';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, takeUntil } from 'rxjs/operators';

import { AddressService } from 'src/app/services/address/address.service';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { eMfaStatuses, UserSessionService } from 'src/app/services/user-session/user-session.service';
import { birthdayValidator, coutryPostalMatchValidator, POboxValidator, POboxValidatorGroup, mustBeTruthy, NAME_PATTERN, SCREENNAME_PATTERN, streetValidator } from 'src/app/services/customFormValidators';
import { isUndefined } from 'src/app/services/codeUtils';
import { CustomerModel } from 'src/app/models/customer-model';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-signup-step-two',
  templateUrl: './signup-step-two.component.html',
  styleUrls: ['./signup-step-two.component.scss'],
})

export class SignupStepTwoComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() public pageParams: any
  @Input() kycFailProcess: boolean = false;
  @Input() wrongPhone: boolean;
  @Input() KYCError;

  public infoForm: FormGroup;
  public salutation: AbstractControl;
  public firstName: AbstractControl;
  public lastName: AbstractControl;
  public middleName: AbstractControl;
  public streetGroup: AbstractControl;
  public street: AbstractControl;
  public street2: AbstractControl;
  public city: AbstractControl;
  public autosearch: AbstractControl;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;
  public countryInfoGroup: AbstractControl;
  public country: AbstractControl;
  public postalCode: AbstractControl;
  public province: AbstractControl;
  public phoneNumber: AbstractControl;
  public ssn1: AbstractControl;
  public ssn2: AbstractControl;
  public ssn3: AbstractControl;
  public certOver18: AbstractControl;
  public ackRegulations: AbstractControl;
  public ackRegulationsEmail: AbstractControl;
  public ackRegulationsCasino: AbstractControl;
  public ackRegulationsOtherOption: AbstractControl;
  public allowPromoSms: AbstractControl;
  public allowPromoEmails: AbstractControl;
  public allowPromoAll: AbstractControl;
  public genderPrefix: any;

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public ackRegulationsCasinoName: string;
  public ackRegulationsName: string;
  public ackRegulationsOtherOptionName: string;
  // public ackRegulationsPAOption: string;
  public addresses = [];
  public bonusCode: any;
  public buttonDisabled: boolean = false;
  public csrf_token: string;
  public customer: CustomerModel;
  public customerWillLogout: boolean = false;
  public environmentName: string;
  public error = null;
  public featureSiteTermsLink: string;
  public registrationSuccessful: boolean = false;
  public legalAge: number;
  public migrated: boolean = false;
  public offer: any;
  public promoCode: string;
  public provinces: any[];
  public refreshedCustomer: boolean = false;
  public responsibleGamingNumber: string;
  public selectedCountry: string;
  public selectedCountryCode: string = 'USA';
  public showAddressResults = false;
  public showAddressFields = false;
  public welcomePackageImgUrl: string;

  public aliasNameCheck: boolean;
  public displayRGLogo: boolean;
  public isSSNRequired: boolean;

  public aliasName: AbstractControl;
  public isMFAFirst: boolean = false;
  public wrongPhoneNumber: boolean;

  public isMfaEnabled: boolean = false;
  public streetRegExpOn: boolean = false;

  public addressElProps = {
    inputStyle: 'none',
    label: 'or enter address manually',
    textAlign: 'left',
  };
  middleNameOnStepTwo: boolean;
  salutationOnStepTwo: boolean;
  phoneNumberStepTwo: boolean;
  certOver18OnStepTwo: any;
  ack2AndAck3Combined: boolean;
  pepValue: any;
  onFooterText: any;
  showPepError: boolean = false;
  public isIos: boolean = false;
  public isIosWeb: boolean = false;
  constructor(
    private addressService: AddressService,
    private appLinksService: AppLinksService,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private events: EventsService,
    private globalErrorHandler: GlobalErrorHandlerService,
    private logoutService: LogoutService,
    private navigator: Navigator,
    private platform: Platform,
    private userSessionService: UserSessionService,
    private successMessageService: SuccessMessageService,
  ) { }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.closeModal();
  }

  ngOnInit(): void {
    if (!!this.pageParams) {
      this.migrated = this.pageParams.migrated;
      this.bonusCode = this.pageParams.bonusCode;
    }
    this.isIos = this.platform.is("ios");
    this.isIosWeb = this.platform.is("ios") && !this.platform.is("ipad") && this.platform.is("mobileweb");

    this.selectedCountry = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
    this.aliasNameCheck = this.configService.getConfig().FEATURE_SIGNUP_SHOW_ALIAS_FIELD === '1' ? true : false;
    this.displayRGLogo = this.configService.getConfig().FEATURE_SHOW_RG_LOGO === '1' ? true : false;
    this.isSSNRequired = this.configService.getConfig().FEATURE_SIGNUP_SHOW_SSN_FIELD === '1' ? true : false;

    this.phoneNumberStepTwo = this.configService.getConfig().FEATURE_PHONE_STEP_TWO === '1' ? true : false;

    this.legalAge = this.configService.getConfig().FEATURE_LEGAL_AGE ?? 21;
    this.ackRegulationsName = this.configService.getConfig().SIGNUP_ACKNOWLEDGMENT_1 ?? "I certify that all the information I provide during account creation is true and accurate";
    this.ackRegulationsCasinoName = this.configService.getConfig().SIGNUP_ACKNOWLEDGMENT_2 ?? "I am not a key casino employee or any casino's employee prohibited from wagering in any casino or simlucasting facility in the State of New Jersey or otherwise prohibited from participating in gaming.";
    this.ackRegulationsOtherOptionName = this.configService.getConfig().SIGNUP_ACKNOWLEDGMENT_3 ?? "I understand that I am prohibited from allowing any other person to access or use this gaming account.";
    // this.ackRegulationsPAOption = this.configService.getConfig().SIGNUP_ACKNOWLEDGMENT_4 ?? "I acknowledge any violations of the interactive gaming regulations are subject to the penalties provided in the act and may result in criminal prosecution under 18 Pa.C.S. (relating to Pennsylvania Crimes Code).";
    this.streetRegExpOn = this.configService.getConfig().FEATURE_STREET_REGEX_ON === '1' ? true : false;

    this.middleNameOnStepTwo = this.configService.getConfig().FEATURE_MIDDLE_NAME_STEP_TWO === '1' ? true : false;
    this.salutationOnStepTwo = this.configService.getConfig().FEATURE_SALUTATION_STEP_TWO === '1' ? true : false;

    this.certOver18OnStepTwo = this.configService.getConfig().FEATURE_CERT_OVER_STEP_TWO === '1' ? true : false;

    this.ack2AndAck3Combined = this.configService.getConfig().FEATURE_ACK2_ACK3_COMBINED_STEP_TWO === '1' ? true : false;

    this.onFooterText = this.configService.getConfig().FEATURE_ON_STEP_TWO_FOOTER_TEXT || '';


    this.infoForm = new FormGroup({
      clientapp: new FormControl(''),
      csrf: new FormControl(),
      salutation: new FormControl(''),
      autosearch: new FormControl(''),
      firstName: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      middleName: new FormControl('', [Validators.pattern(NAME_PATTERN)]),
      aliasName: new FormControl(({ value: "", disabled: !this.aliasNameCheck }), [Validators.pattern(SCREENNAME_PATTERN)]),
      streetGroup: new FormGroup(
        {
          street: new FormControl('', [Validators.required, this.streetRegExpOn ? streetValidator : POboxValidator]),
          street2: new FormControl('', [POboxValidator]),
        }, POboxValidatorGroup
      ),
      city: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      countryInfoGroup: new FormGroup(
        {
          country: new FormControl({ value: '', disabled: true }, [Validators.required]),
          postalCode: new FormControl('', [Validators.required]),
        },
        coutryPostalMatchValidator
      ),
      dateOfBirthGroup: new FormGroup(
        {
          dateOfBirthYear: new FormControl('', [Validators.required]),
          dateOfBirthDay: new FormControl('', [Validators.required]),
          dateOfBirthMonth: new FormControl('', [Validators.required]),
          hiddenLegalAge: new FormControl(this.legalAge)
        },
        birthdayValidator
      ),
      province: new FormControl('NJ', [Validators.required]),
      // phoneNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(10), Validators.maxLength(10)]),
      customerAttributionData: new FormControl(''),
      extAffiliateId: new FormControl(''),
      ssn3: new FormControl(({ value: "", disabled: !this.isSSNRequired }), [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(4), Validators.maxLength(4)]),

      // certOver18: new FormControl(true, [mustBeTruthy]),

      ackRegulations: new FormControl(({ value: false, disabled: false }), [mustBeTruthy]),
      ackRegulationsEmail: new FormControl(({ value: true, disabled: false })),
      ackRegulationsCasino: new FormControl(({ value: false, disabled: false }), [mustBeTruthy]),
      ackRegulationsOtherOption: new FormControl(({ value: false, disabled: false }), [mustBeTruthy]),
      // ackRegulationsPAOption: new FormControl(({ value: false, disabled: false }), [mustBeTruthy]),
      allowPromoSms: new FormControl(({ value: false, disabled: false })),
      allowPromoEmails: new FormControl(({ value: false, disabled: false })),
      allowPromoAll: new FormControl(({ value: false, disabled: false })),
      allowPromoPost: new FormControl(({ value: false, disabled: false })),
    });

    if (this.certOver18OnStepTwo) {
      this.infoForm.addControl('certOver18', new FormControl(true, [mustBeTruthy]
      ));
    }

    if (this.phoneNumberStepTwo) {
      this.infoForm.addControl('phoneNumber', new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(10), Validators.maxLength(10)]
      ));
    }

    const formgroup = this.infoForm.get('countryInfoGroup');
    formgroup.get('country').patchValue(this.selectedCountryCode);

    this.getProvinces();

    this.userSessionService.getCustomer().subscribe(customer => {
      if (customer) {
        this.customer = customer;
        if (this.customer != null) {
          this.promoCode = '';//this.customer.customData.find(data => data.key === 'promo_code').value;
        }
      }
    });


    this.infoForm.get('clientapp').setValue(this.configService.getClientApp());

    if (this.salutationOnStepTwo) {
      this.salutation = this.infoForm.get('salutation');
    }
    this.firstName = this.infoForm.get('firstName');
    this.lastName = this.infoForm.get('lastName');

    if (this.middleNameOnStepTwo) {
      this.middleName = this.infoForm.get('middleName');
    }

    this.streetGroup = this.infoForm.get('streetGroup');
    this.street = this.streetGroup.get('street');
    this.street2 = this.streetGroup.get('street2');

    this.city = this.infoForm.get('city');
    this.autosearch = this.infoForm.get('autosearch');

    this.dateOfBirthGroup = this.infoForm.get('dateOfBirthGroup');
    this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
    this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
    this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');

    this.countryInfoGroup = this.infoForm.get('countryInfoGroup');
    this.country = this.countryInfoGroup.get('country');
    this.postalCode = this.countryInfoGroup.get('postalCode');
    this.province = this.infoForm.get('province');

    if (this.phoneNumberStepTwo) {
      this.phoneNumber = this.infoForm.get('phoneNumber');
    }

    this.ackRegulations = this.infoForm.get('ackRegulations');
    this.ackRegulationsCasino = this.infoForm.get('ackRegulationsCasino');
    this.ackRegulationsEmail = this.infoForm.get('ackRegulationsEmail');
    this.ackRegulationsOtherOption = this.infoForm.get('ackRegulationsOtherOption');
    this.allowPromoSms = this.infoForm.get('allowPromoSms');
    this.allowPromoEmails = this.infoForm.get('allowPromoEmails');
    this.allowPromoAll = this.infoForm.get('allowPromoAll');

    this.certOver18 = this.infoForm.get('certOver18');

    if (this.isSSNRequired) this.ssn3 = this.infoForm.get('ssn3');
    if (this.aliasNameCheck) this.aliasName = this.infoForm.get('aliasName');
    if (this.kycFailProcess) this.addAdditionalKycControls();

    const googlePlaceDebounceTime = this.configService.getConfig().FEATURE_GOOGLE_PLACE_DEBOUNCE_TIME ?? 0;
    // watch the form changing the values on autosearch field
    this.infoForm.valueChanges.pipe(
      takeUntil(this.ngUnsubscribe),
      map(form => form['autosearch']),
      distinctUntilChanged(),
      debounceTime(~~googlePlaceDebounceTime),
      switchMap(this.addressService.completeAddress)
    ).subscribe(data => {
      if (data.payload) {
        this.addresses = data.payload;
        this.showAddressResults = true;
      }
    });

    this.prePopulateFields();

    if (this.KYCError) {
      this.handleError(this.KYCError);
    }
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.generateCsrfToken();
    this.refreshedCustomer = false;
  }

  generateCsrfToken() {
    this.authenticationService.getCsrfToken().subscribe(response => {
      if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
        this.csrf_token = response.payload.token;
        this.infoForm.controls['csrf'].setValue(response.payload.token);
        this.addressService.setCSRFToken(this.csrf_token);
      }
    });
  }

  private addAdditionalKycControls() {
    this.infoForm.addControl('ssn1', new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(3), Validators.maxLength(3)]));
    this.infoForm.addControl('ssn2', new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(2), Validators.maxLength(3)]));
    this.ssn1 = this.infoForm.get('ssn1');
    this.ssn2 = this.infoForm.get('ssn2');
  }

  public getProvinces() {
    this.addressService.callGetStatesByCountry(this.selectedCountryCode).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          const provs = response.payload;
          this.provinces = [];
          for (const p in provs) {
            this.provinces.push({ code: p, name: provs[p] });
          }
        }
      },
      error: error => console.error('callGetStatesByCountry ', error)
    });
  }

  private prePopulateFields() {
    this.authenticationService.callGetAccount().subscribe(response => {
      if (response && !!response.result) {
        const customerInfo = response.payload.customer;

        let usersYear = null;
        let usersMonth = null;
        let usersDay = '';
        if (response.result == 1) {
          if (Object.keys(customerInfo.address).length == 0) {
            this.showAddressFields = false;
            this.showAddressResults = false;
            this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
            if (!this.showAddressFields) this.infoForm.controls['autosearch'].setValue('');
          } else if (Object.keys(customerInfo.address).length > 0 && customerInfo.address.constructor === Object) {
            this.showAddressFields = true;
            this.showAddressResults = true;

            this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
            if (!this.showAddressFields) this.infoForm.controls['autosearch'].setValue('');

            //birthdate format
            if (customerInfo.birthDate) {
              const birthDateFormattedArray = customerInfo.birthDate.split('-');
              usersYear = Number(birthDateFormattedArray[0]);
              usersMonth = Number(birthDateFormattedArray[1]);
              usersDay = birthDateFormattedArray[2]; // don't make it a Number !!!
            }
          }

          const selectProvince = this.provinces.filter(item => {
            return item.code == customerInfo.address['state'];
          }).map(item => {
            return item.code;
          }).join('') || 'PA';

          this.wrongPhoneNumber = this.wrongPhone;

          this.infoForm.patchValue({
            salutation: customerInfo.salutation || 'Mr',
            firstName: customerInfo.firstName || '',
            lastName: customerInfo.lastName || '',
            middleName: customerInfo.middleName || '',
            aliasName: customerInfo.nickName || "",
            phoneNumber: this.wrongPhoneNumber ? '' : customerInfo.address['phoneNumber'] || '',
            city: customerInfo.address['city'] || '',
            province: selectProvince,
            allowPromoEmails: 'allowPromoEmails' in customerInfo ? customerInfo.allowPromoEmails : false,
            allowPromoSms: 'allowPromoSms' in customerInfo ? customerInfo.allowPromoSms : false,
            allowPromoPost: 'allowPromoPost' in customerInfo ? customerInfo.allowPromoPost : false,
            streetGroup: {
              street: customerInfo.address['street'] || '',
              street2: customerInfo.address['street2'] || '',
            },
            countryInfoGroup: {
              postalCode: customerInfo.address['postalCode'] || '',
            },
            dateOfBirthGroup: {
              dateOfBirthDay: customerInfo.birthDate ? usersDay : '',
              dateOfBirthMonth: customerInfo.birthDate ? usersMonth : '',
              dateOfBirthYear: customerInfo.birthDate ? usersYear : '',
            },
          });

          //this.genderPrefix = customerInfo.salutation ? customerInfo.salutation : "Mr";
        }
      }
    },
      error => {
        console.error(error);
      }
    );
  }

  get months() {

    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if (this.platform.is("capacitor")) {
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    }
    if (this.dateOfBirthYear.value == this.years[0]) {
      let extra = 11 - new Date().getMonth();
      for (extra; extra > 0; extra--) {
        months.pop();
        if (this.dateOfBirthMonth.value == months.length + 1) this.dateOfBirthMonth.setValue(months.length)
      }
    }
    return months;
  }

  get days() {
    const days = [...Array(31).keys()]
    const displayDays = days.map(val => val + 1).map(val => (val < 10) ? "0" + val.toString() : val.toString());
    if (
      this.dateOfBirthYear.value == this.years[0] &&
      this.dateOfBirthMonth.value - 1 == this.months.indexOf(this.months[this.months.length - 1])
    ) {
      let extra = 31 - new Date().getDate();
      for (extra; extra > 0; extra--) {
        displayDays.pop();
        if (this.dateOfBirthDay.value == displayDays.length + 1) this.dateOfBirthDay.setValue(displayDays[displayDays.length - 1]);
      }
    }
    return displayDays;
  }

  get years() {
    const years = [];
    const min = new Date().getFullYear() - 100,
      max = new Date().getFullYear() - this.legalAge;
    for (let i = max; i >= min; i--) {
      years.push(i)
    }
    return years;
  }

  hideSearchList() {
    this.showAddressResults = false;
  }

  // google places
  fillInAddress(result) {
    this.showAddressResults = false;
    this.toggleAddress();
    this.infoForm.controls['autosearch'].setValue(result.address);
    // get the address details and set the fields with data
    this.addressService.addressDetails(result.place_id, this.csrf_token).subscribe(response => {
      const place = response.payload;
      let street = '';
      for (let i = 0; i < place.address_components.length; i++) {
        const addressType = place.address_components[i].types[0];
        if (this.googleAddressTypes[addressType]) {
          const val = place.address_components[i][this.googleAddressTypes[addressType]];
          if (this.addressFieldsMap[addressType]) {
            const inputName = this.addressFieldsMap[addressType];
            // street = street_number + route
            if (inputName === 'street') {
              street = street + val + ' ';
              const streetGroup = <FormGroup>this.streetGroup;
              streetGroup.controls[inputName].setValue(street);
              // set postal code to countryInfoGroup
            } else if (inputName === 'postalCode') {
              const countryInfoGroup = <FormGroup>this.countryInfoGroup;
              countryInfoGroup.controls[inputName].setValue(val);
            } else {
              this.infoForm.controls[inputName].setValue(val);
            }
          }
        }
      }
    });
    return false;
  }

  toggleAddress() {
    this.showAddressFields = this.showAddressFields ? false : true;
    this.showAddressResults = this.showAddressFields ? true : false;
    this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
    if (!this.showAddressFields) {
      this.infoForm.controls['autosearch'].setValue('');
      this.street.setErrors({ incorrect: true });
      this.street2.setErrors({ incorrect: true });
      this.city.setErrors({ incorrect: true });
      this.province.setErrors({ incorrect: true });
      this.postalCode.setErrors({ incorrect: true });
    } else {
      this.street.setValue('');
      this.street2.setValue('');
      this.city.setValue('');
      this.province.setValue('');
      this.postalCode.setValue('');
    }
  }

  get googleAddressTypes() {
    return {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'short_name',
      country: 'long_name',
      postal_code: 'short_name',
    };
  }

  get addressFieldsMap() {
    return {
      street_number: 'street',
      route: 'street',
      locality: 'city',
      administrative_area_level_1: 'province',
      // country: 'country',
      postal_code: 'postalCode',
    };
  }
  updatePromoPreferences(allowPromoAll: boolean): void {
    if (allowPromoAll) {
      this.infoForm.patchValue({
        allowPromoEmails: true,
        allowPromoPost: true,
        allowPromoSms: true
      });

    }
  }
  onSubmit() {
    this.buttonDisabled = true;
    this.infoForm.addControl('street', new FormControl(this.streetGroup.get('street').value));
    this.infoForm.addControl('street2', new FormControl(this.streetGroup.get('street2').value));
    if (this.isSSNRequired) {
      const governmentIdValue = this.kycFailProcess ? this.ssn1.value + this.ssn2.value + this.ssn3.value : this.ssn3.value;
      this.infoForm.addControl('governmentId', new FormControl(governmentIdValue));
      this.infoForm.value.governmentId = governmentIdValue;
    }

    this.updatePromoPreferences(this.allowPromoAll.value);

    const formObj: any = this.infoForm.value;
    formObj.country = this.selectedCountryCode;

    if (this.migrated) {
      formObj.promo_code = this.pageParams.bonusCode;
    }

    this.authenticationService.callSignupStep2(formObj, this.migrated).subscribe({
      next: (response: any) => {
        this.globalErrorHandler.clear();
        this.buttonDisabled = false;
        if (response && !!response.result) {
          if (response.result == 1) {
            const payloadObject = response.payload;
            if ((Object.keys(payloadObject).length > 0) && payloadObject.comments === "CUSTOMER_MFA_REQUIRED") {
              this.isMFAFirst = true;
              return this.doMFA(this.isMFAFirst);
            } else if ((Object.keys(payloadObject).length > 0 && payloadObject.constructor === Object) && Object.prototype.hasOwnProperty.call(payloadObject, 'is_verified')) {
              const isVerified: boolean = response.payload.is_verified;
              const kycStep: string = response.payload.kyc_step;
              const kyc_attempts: string = response.payload.kyc_attempts;
              const kycFailErrors: any = response.payload.kyc_fail_errors;
              const idScanResult: string = response.payload.id_scan_result;
              const MFAStatus = this.userSessionService.getMFAApproval();

              if (isVerified == true && MFAStatus == "true") {
                return this.activateCustomer();
              } else {
                if (isVerified == true) {
                  return this.doMFA();
                } else {
                  this.startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult);
                }
              }

              /*else if (!isVerified) {
            let attempts = this.configService.getConfig().FEATURE_KYC_MAX_ATTEMPTS || 3;
            if (kycAttempts < attempts) {
              this.navigator.navigateTo("InvalidKycComponent");
            }
            else if (kycAttempts >= attempts) {
              this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true });
            }
          }*/
            }/*else if (Object.keys(payloadObject).length == 0) {
              this.activateCustomer();
            }*/
          } else {
            this.registrationSuccessful = false;
            this.infoForm.removeControl('street');
            this.infoForm.removeControl('street2');
          }
        }
      },
      error: (error) => {
        this.handleError(error);
      }
    })
  }

  private handleError(error) {
    this.buttonDisabled = false;
    this.generateCsrfToken();
    this.globalErrorHandler.setErrorCode(error.getErrorCode().toUpperCase());

    switch (error.getErrorCode().toUpperCase()) {
      case 'AGE_VERIFICATION_FAILED':
        this.globalErrorHandler.setErrorMessage('Form has errors, please see below');
        this.dateOfBirthGroup.setErrors({ 'AGE_VERIFICATION_FAILED': true })
        this.dateOfBirthGroup.markAsTouched();
        this.dateOfBirthGroup.markAsDirty();
        break;
      case 'ALREADY_HAS_ACCOUNT':
        this.globalErrorHandler.setErrorMessage('It appears this account has already been created.');
        break;
      case 'CUSTOMER_IN_BLACKLIST':
        this.globalErrorHandler.setErrorMessage('Cannot create account please contact customer support.');
        break;
      case 'GOVERNMENT_ID_ALREADY_EXISTS':
        this.globalErrorHandler.setErrorMessage('Cannot create account please verify your data. Contact support if the issue continues.');
        break;
      case 'INVALID_BIRTHDATE':
        this.globalErrorHandler.setErrorMessage('The birthdate entered is invalid');
        break;
      case 'BAD_CONTENT':
        this.globalErrorHandler.setErrorMessage(error.getErrorMessage());
        break;
      case 'TOKEN_INVALID':
        this.globalErrorHandler.setErrorMessage('Security checks discovered inconsistency with this form. Please try again.');
        break;
      case 'PHONE_ALREADY_EXISTS':
        this.globalErrorHandler.setErrorTitle("Sorry, the phone number cannot be used.");
        this.globalErrorHandler.setErrorMessage("Please enter an alternate number or contact Support for help");
        break;
      case 'IDNOW_RESPONSE_INVALID':
        this.globalErrorHandler.setErrorMessage("It appears this account has already been created. Please contact customer support.");
        break;
      default:
        this.globalErrorHandler.setErrorMessage(error.getErrorMessage());
        break;

    }

    this.globalErrorHandler.setErrorMessage(error.getErrorMessage());
    this.error = error;
    this.content.scrollToTop(10);
    this.infoForm.removeControl('street');
    this.infoForm.removeControl('street2');
  }

  public verifyKYC(): any {
    const customer_id = this.authenticationService.customer.customerId;
    const government_id = this.infoForm.value.governmentId;
    const obj = {
      customer_id,
      government_id,
    }
    this.authenticationService.callVerifyKYC(obj).subscribe({
      next: (response) => {
        if (response.result == 1) {
          const payloadObject = response.payload;
          if ((Object.keys(payloadObject).length > 0 && payloadObject.constructor === Object) && Object.prototype.hasOwnProperty.call(payloadObject, 'is_verified')) {
            const isVerified = response.payload.is_verified;
            const kycStep = response.payload.kyc_step;
            const kyc_attempts = response.payload.kyc_attempts;
            const kycFailErrors = response.payload.kyc_fail_errors;
            const idScanResult = response.payload.id_scan_result;

            if (isVerified == true) return this.activateCustomer();
            this.startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult);
          }
        }
      },
      error: (error) => {
        console.log("ERROR", error)
        this.handleError(error);
      }
    });
  }

  startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult?) {
    if (kycStep && kycStep.toUpperCase() == 'PENDING_KBA') return this.navigator.navigateTo("IdologyKbaComponent");
    if (kycStep && kycStep.toUpperCase() == 'PENDING_RETRY') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: false, dontCallAppInitNext: true, kyc_attempts });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_SOVOS') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true, dontCallAppInitNext: true, kyc_attempts });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_CS') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true, dontCallAppInitNext: true, kyc_attempts });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_IDSCAN' && idScanResult === 'pending') return this.navigator.navigateTo("CamsComponent");
    if (kycStep && kycStep.toUpperCase() == 'PENDING_IDSCAN' && idScanResult !== 'pending') return this.navigator.navigateTo("CamsComponent");
    return this.navigator.navigateTo("InvalidKycComponent", {}, { kycFailErrors: kycFailErrors, dontCallAppInitNext: true });
  }

  signUpStepTwo = () => {
    this.navigator.navigateTo("SignupStepTwoComponent", { forceModal: true }, { pageParams: this.pageParams, wrongPhone: true });
  }

  public doMFA(isMFAFirst?: boolean): any {
    // const customer_id = this.authenticationService.customer.customerId;
    //this.events.publish('event:signupcomplete', { customer_id: customer_id });
    const isSMS_OR_EMAIL = this.configService.getConfig().FEATURE_MFA_TYPE ?? 'SMS';
    const mfa_statuses = this.configService.getConfig().FEATURE_MFA_STATUSES ?? 'ACTIVE, REAL_LOCKED, SELF_EXCLUDED_COOL_OFF, FUNDS_HELD';

    return this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {
      if (this.userSessionService.getLoginResponseForMFA() && mfa_statuses.toUpperCase().includes(customer.status.toUpperCase())) {
        this.userSessionService.setMFAStatus(eMfaStatuses.required);
        if (isSMS_OR_EMAIL == 'SMS') {
          if (isMFAFirst) {
            this.navigator.navigateTo("AuthenticatorOptionComponent", { forceModal: true }, { customerId: customer.customerId, isMFAFirst: this.isMFAFirst, governmentId: this.infoForm.value.governmentId, onClose: this.signUpStepTwo })
          } else {
            this.navigator.navigateTo("AuthenticatorOptionComponent", { forceModal: true }, { customerId: customer.customerId, callback: this.activateCustomer })
          }
        } else {
          this.navigator.navigateTo("CodeLoginPage", { forceModal: true }, { customerId: customer.customerId, callback: this.activateCustomer })
        }
      } else {
        if (isMFAFirst) {
          this.navigator.navigateTo("AuthenticatorOptionComponent", { forceModal: true }, { customerId: customer.customerId, isMFAFirst: this.isMFAFirst, governmentId: this.infoForm.value.governmentId, onClose: this.signUpStepTwo })
        } else {
          this.activateCustomer();
        }
      }
    });
  }

  activateCustomer = () => {
    this.events.publish('event:signupResult:flag');
    this.navigator.navigateTo("SignupResultComponent", { forceModal: true });
  }

  closeModal = () => {
    this.navigator.dismissAll();
    this.logoutService.onLogout({ reason: 'CLOSE_SIGNUP_STEP2' });
  };

  openMatchedExternalLinks(code, title) {
    return this.appLinksService.openMatchedExternalLinksPopover(code, title)
  }

  validateZipCode() {
    if (this.countryInfoGroup.get('country').value) {
      if (this.countryInfoGroup.hasError('mismatch')) {
        this.countryInfoGroup.get('postalCode').setErrors({ 'incorrect': true });
      }
    }
  }
}
